import { gql } from "@apollo/client";

const UPDATE_RANKING_CATEGORY_RULE = gql`
  mutation updateCategoryRule(
    $id: Int!
    $category: Int!
    $sector: String
    $numberOfTournaments: Int
    $tournamentCategories: [Int!]
    $licenseSubtypes: String
    $thirdPartyLicense: Int
    $coefficient: Float
    $enableMaxPointTotal: Boolean
    $maxPointTotal: Int
    $placeMultipliers: [PlaceMultiplierInput!]
    $subRuleCategories: [Int!]
  ) {
    updateCategoryRule(
      updateCategoryRuleInput: {
        id: $id
        category: $category
        sector: $sector
        numberOfTournaments: $numberOfTournaments
        licenseSubtypes: $licenseSubtypes
        tournamentCategories: $tournamentCategories
        thirdPartyLicense: $thirdPartyLicense
        coefficient: $coefficient
        enableMaxPointTotal: $enableMaxPointTotal
        maxPointTotal: $maxPointTotal
        placeMultipliers: $placeMultipliers
        subRuleCategories: $subRuleCategories
      }
    ) {
      id
    }
  }
`;

export default UPDATE_RANKING_CATEGORY_RULE;
